import React from 'react';
import {render, hydrate} from 'react-dom';
import {BrowserRouter} from 'react-router-dom';
import {Provider} from 'react-redux';
import '@babel/polyfill';
import configureStore from './app/configurestore';
import initialState from './app/initialstate';
import Routes from './app/Routes';
import './common/utils/svg';
import config from './auth/config';
import {Providers, Msal2Provider} from '@microsoft/mgt';
import {MsalService} from '@ey/voltron-core';
import { checkUserAcceptedPaansPolicy } from '@features/paans/paans';
import { getErrorMessage, getErrorMessageFromResponse } from '@util/utils';

document.addEventListener('DOMContentLoaded', () => {
	const store = configureStore(initialState);

	store.dispatch({ type: 'HOME_LOGIN', isOnline: true }).then(() => {
		const isAdmin = window.location.pathname == "/admin" ? true : false;
		store
			.dispatch(checkUserAcceptedPaansPolicy(isAdmin, window.location.href))
			.then(() => {
				let userHasAcceptedPolicy = store.getState().paansuserdata;
				let hasaccepted = userHasAcceptedPolicy.hasAccepted;
				let redirectUrl = userHasAcceptedPolicy.redirectUrl;
				if (hasaccepted !== undefined && redirectUrl !== undefined) {
					if (hasaccepted === false) {
						window.location.href = redirectUrl;
					}
				}
			})
			.catch((paansError) => {
				let errorMessage = getErrorMessageFromResponse(getErrorMessage(paansError));
				console.log('Error in PAANS: ', errorMessage);
			});

		const authService = new MsalService(config);
		const account = authService.getActiveAccount();
		if (account) {
			const scopes = [
				'user.read',
				'user.read.all',
				'Presence.Read',
				'Presence.Read.All',
				'people.read',
				'contacts.read',
				'sites.read.all',
				'Mail.ReadBasic',
				'people.read.all'
			];

			Providers.globalProvider = new Msal2Provider({
				clientId: config.auth.clientId,
				authority: config.auth.authority,
				scopes: scopes,
				cache: config.cache,
				loginHint: account.username
			});
		}

		const renderMethod = render; //process.env.NODE_ENV !== 'production' ? render : hydrate;

		renderMethod(
			<Provider store={store}>
				<BrowserRouter>
					<Routes />
				</BrowserRouter>
			</Provider>,
			document.getElementById('mount')
		);
	});
});
